/**
 * Frontend network configuration (extends shared config for Cloudflare Pages)
 */

import { baseSepolia, base } from 'viem/chains'
import type { Chain } from 'viem'
import {
  BASE_NETWORKS,
  USDC_ADDRESSES,
  GAS_ESTIMATES,
  type NetworkName,
  type BaseNetworkConfig,
} from '@shared/config/networks'

export type { NetworkName }
export { USDC_ADDRESSES, GAS_ESTIMATES }

export interface NetworkConfig extends BaseNetworkConfig {
  chain: Chain
}

// Extend base networks with viem Chain objects
export const NETWORKS: Record<NetworkName, NetworkConfig> = {
  'base-sepolia': {
    ...BASE_NETWORKS['base-sepolia'],
    chain: baseSepolia,
  },
  base: {
    ...BASE_NETWORKS.base,
    chain: base,
  },
}

/**
 * Get the current network from environment variables
 */
export function getCurrentNetwork(): NetworkName {
  const network = import.meta.env.VITE_BASE_NETWORK || 'base-sepolia'

  if (network !== 'base' && network !== 'base-sepolia') {
    console.warn(`Invalid network "${network}", defaulting to base-sepolia`)
    return 'base-sepolia'
  }

  return network
}

/**
 * Get network configuration
 */
export function getNetworkConfig(network?: NetworkName): NetworkConfig {
  const networkName = network || getCurrentNetwork()
  return NETWORKS[networkName]
}
